import React from 'react';
import i18n from '../../../../i18n';
import { getOrganizationList } from '../../../../models/organization';
import { getGroupsList } from '../../../../models/groups';
import { HomeBanner } from '../../../home/homeBanner';
import { SideBar } from '../../components/Sidebar/Sidebar';
import Select from 'react-select';
import { getWalletUsers } from '../../../../models/users';
import Dropdown from '../../../common/DropDown';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { Download, Printer, FileSpreadsheet, ArrowLeft } from 'lucide-react';
import FilterSection from '../../../common/Filter';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { getLoggedUser } from '../../../../state/user';
import { getWalletTransactions } from './services/WalletTransactionServices';
import NewDropdown from '../../../common/NewDropDown';
import StatusBadge from '../../../common/StatusBadge';
import { TRANSACTION_STATUS } from '../../../../constants/status';
import { ActionModal } from './components/ActionModal';
import { withRouter } from '../../../../hoc/withRouter';
import { imageUrl } from '../../../../constants/global';

const user = getLoggedUser();

class AuctionTransaction extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        startDate: null,
        endDate: null,
        payment: '',
        client: '',
        bidder: null,
      },
      status: null,
      groupId: null,
      input: {},
      clients: [],
      groups: [],
      customers: [],
      auctionPayments: [],
      isLoading: false,
      limit: 15,
      page: 1,
      columns: [
        {
          id: 1,
          name: 'Sl No',
          width: '70px',
          sortable: false,
          center: true,
          cell: (row, i) => i + 1,
        },
        {
          id: 2,
          name: 'ID',
          width: '80px',
          sortable: true,
          center: true,
          cell: (row) => row.id,
        },
        {
          id: 3,
          name: i18n.t('mzad_id'),
          minWidth: '120px',
          cell: (row) => `Mzad ${row.auction}`,
        },
        {
          id: 4,
          name: i18n.t('group_name'),
          minWidth: '140px',
          cell: (row) => row.group_name,
          wrap: true,
        },
        {
          id: 5,
          name: i18n.t('username'),
          minWidth: '140px',
          cell: (row) => row.username,
          wrap: true,
        },
        {
          id: 6,
          name: i18n.t('email'),
          minWidth: '180px',
          cell: (row) => row.email,
          wrap: true,
        },
        {
          id: 7,
          name: i18n.t('transaction'),
          width: '110px',
          center: true,
          cell: (row) => row.transaction_id,
        },
        {
          id: 8,
          name: i18n.t('deposite'),
          width: '120px',
          right: true,
          cell: (row) => row.credit,
        },
        {
          id: 9,
          name: i18n.t('withdraw'),
          width: '120px',
          right: true,
          cell: (row) => row.debit,
        },
        {
          id: 10,
          name: i18n.t('hold'),
          width: '120px',
          right: true,
          cell: (row) => row.hold_amount,
        },
        {
          id: 11,
          name: i18n.t('balance'),
          width: '130px',
          right: true,
          cell: (row) => row.balance,
        },
        {
          id: 12,
          name: i18n.t('client_amount'),
          width: '130px',
          right: true,
          cell: (row) => row.client_amount,
        },
        {
          id: 13,
          name: i18n.t('reference'),
          minWidth: '130px',
          cell: (row) => row.reference,
          wrap: true,
        },
        {
          id: 14,
          name: i18n.t('type'),
          width: '120px',
          center: true,
          cell: (row) => row.type,
        },
        {
          id: 15,
          name: i18n.t('payment_type'),
          width: '140px',
          center: true,
          cell: (row) => row.method,
        },
        {
          id: 16,
          name: i18n.t('status'),
          width: '130px',
          center: true,
          cell: (row) => <StatusBadge status={TRANSACTION_STATUS[row.status]} />,
        },
        {
          id: 17,
          name: i18n.t('date'),
          width: '140px',
          center: true,
          cell: (row) => row?.created_at,
        },
        {
          id: 18,
          name: i18n.t('receipt'),
          width: '120px',
          center: true,
          cell: (row) =>
            row.file_receipt ? (
              <a
                href={`${imageUrl}uploads/wallet/receipt/${row.file_receipt}`}
                target="_blank"
                rel="noopener noreferrer"
                className="receipt-link"
              >
                {i18n.t('receipt')}
              </a>
            ) : (
              <span className="no-receipt">-</span>
            ),
        },
        {
          id: 20,
          name: i18n.t('action'),
          minWidth: '160px',
          center: true,
          cell: (row) => {
            const canShow =
              (row.status === 'B' && (user.role === 'FS' || user.role === 'F')) ||
              (row.status === 'FS' && user.role === 'FM');

            return canShow ? (
              <div className="action-buttons">
                <button className="btn-new btn-action" onClick={() => this.handleActions(row)}>
                  {i18n.t('action')}
                </button>
              </div>
            ) : null;
          },
        },
      ],
      showConfirm: false,
      selectedRow: null,
      confirmAction: null,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    const { groupId } = this.props.params;
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
      payment: params.get('payment') || '',
      client: params.get('client') || '',
      bidder: params.get('bidder') || null,
    };
    const status = params.get('status') || 'pending';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ groupId, search, status, page, limit }, () => {
      this.getAllOrganization?.();
      this.getBidders?.();
      this.getauctionPayments();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getauctionPayments() {
    this.setState({ isLoading: true });
    let { limit, page, status, groupId } = this.state;
    let { startDate, endDate, payment, client, bidder } = this.state.search;
    if (!status) {
      return;
    }
    const q = {
      page: page,
      limit: limit,
    };
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;
    if (payment) q.payment = payment;
    if (client) q.client = client;
    if (status) q.status = status;
    if (bidder) q.bidder = bidder;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getWalletTransactions({ ...q, group: groupId, type: 'client_payment' });
    if (response.success) {
      let auctionPayments = response.data;
      let { total } = response.meta;
      this.setState({
        auctionPayments,
        total,
        isLoading: false,
      });
    }
    this.setState({ isLoading: false });
  }
  async getAllOrganization() {
    const response = await getOrganizationList();
    let clients = response.data;
    this.setState({ clients });
  }

  async getBidders() {
    this.setState({ bidderLoading: true });
    const response = await getWalletUsers();
    let data = response.data;
    if (response.success) {
      const customers = data.map((item) => {
        return {
          value: item.id,
          label: item.name + ' (' + item.username + ')',
        };
      });

      this.setState({ bidderLoading: false });
      this.setState({ customers: customers });
    } else {
      this.setState({ bidderLoading: false });
    }
  }

  async getAllGroups() {
    this.setState({ groupLoading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let groups = response.data;
      this.setState({ groups });
      this.setState({ groupLoading: false });
    } else {
      this.setState({ groupLoading: false });
    }
  }

  handleSearchChange = (e) => {
    const { name, value } = e.target;

    this.setState(
      (prevState) => {
        const updatedSearch = { ...prevState.search, [name]: value };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client') {
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.getauctionPayments();
  };

  handleClear = () => {
    const defaultSearch = {
      type: 'enroll',
      payment: '',
      client: '',
      bidder: null,
      refundStatus: this.state.refundStatus,
    };

    this.setState({ search: defaultSearch, groups: [], page: 1 }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit, type: 'enroll' });
      this.getauctionPayments();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getauctionPayments();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getauctionPayments();
    });
  };

  handleActions = (row) => {
    this.setState({
      showConfirm: true,
      selectedRow: row,
    });
  };

  render() {
    const { customers, showConfirm, selectedRow } = this.state;

    return (
      <React.Fragment>
        <HomeBanner />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    {/* Back Button */}
                    <button
                      className="btn-back"
                      onClick={() =>
                        this.props.navigate(`/auction-payment?status=${this.state.status}`)
                      }
                    >
                      <ArrowLeft size={18} className="icon" />
                      <span>Back</span>
                    </button>
                  </div>
                  <div className="card-body">
                    <h3 className="card-title">{i18n.t('auction_payments_transaction')}</h3>
                    <div className="header-action">
                      <NewDropdown
                        label="Export"
                        // loading={export_loading}
                        icon={Download}
                        items={[
                          {
                            label: 'PDF',
                            icon: Printer,
                            onClick: () => this.handleDownload('pdf'),
                          },
                          {
                            label: 'Excel',
                            icon: FileSpreadsheet,
                            onClick: () => this.handleDownload('excel'),
                          },
                        ]}
                      />
                    </div>
                    <FilterSection
                      loading={this.state.isLoading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Start Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="startDate"
                          type="date"
                          name="startDate"
                          value={this.state.search.startDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder=" " // Important: single space for floating effect
                        />
                        <label htmlFor="startDate" className="floating-label">
                          {i18n.t('start_date')}
                        </label>
                      </div>

                      {/* End Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="endDate"
                          type="date"
                          name="endDate"
                          value={this.state.search.endDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder={i18n.t('end_date')}
                        />
                        <label htmlFor="endDate" className="floating-label">
                          {i18n.t('end_date')}
                        </label>
                      </div>

                      {/* Payment Type Dropdown */}
                      <Dropdown
                        name="payment"
                        value={this.state.search.payment}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('payment')}
                        empty={i18n.t('select_payment')}
                        options={[
                          { value: 'online', label: i18n.t('online') },
                          { value: 'offline', label: i18n.t('offline') },
                          { value: 'wallet', label: i18n.t('wallet') },
                        ]}
                      />

                      {/* Bider Dropdown */}
                      <div className="react-select-wrapper">
                        <Select
                          options={customers}
                          value={
                            customers.find((c) => c.value === this.state.search.bidder) || null
                          }
                          onChange={(selectedOption) => {
                            this.setState((prevState) => ({
                              search: {
                                ...prevState.search,
                                bidder: selectedOption ? selectedOption.value : null,
                              },
                            }));
                          }}
                          name="bidder"
                          styles={selectStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          placeholder={i18n.t('search_bidder')}
                          className=""
                        />
                        {/* Only show label when there's a selected value */}

                        <label className="react-select-label">{i18n.t('bidder')}</label>
                      </div>
                    </FilterSection>

                    <div className="Data-Listing">
                      {this.state.isLoading ? (
                        <TableSkeleton columns={6} rows={10} />
                      ) : this.state.auctionPayments.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.state.columns}
                          data={this.state.auctionPayments}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: 'Groups per page:',
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message="No Auction Payments available"
                          actionText="Refresh"
                          onAction={this.getauctionPayments.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ActionModal
          show={showConfirm}
          selectedPayment={selectedRow}
          onClose={() => this.setState({ showConfirm: false })}
          onComplete={() => {
            this.getauctionPayments();
            this.setState({ showConfirm: false, selectedRow: null });
          }}
        />
      </React.Fragment>
    );
  }
}
export default withRouter(AuctionTransaction);
